import { CSSProperties, FC } from 'react';
import { FilePen, Inbox } from 'lucide-react';
import { RiHomeLine } from 'react-icons/ri';
import { TbArchive, TbCirclesRelation, TbRoute, TbSearch, TbSettings, TbTrash, TbUserCircle } from 'react-icons/tb';

import { WorkspaceResourceGlyph } from '@/shared/components/workspace-resources';

export type NavigationRouteIconType =
    | 'home'
    | 'inbox'
    | 'search'
    | 'folders'
    | 'drafts'
    | 'archive'
    | 'investments'
    | 'memos'
    | 'pipelines'
    | 'lifecycles'
    | 'dashboards'
    | 'lists'
    | 'tasks'
    | 'teams'
    | 'profile'
    | 'settings'
    | 'relations'
    | 'trash'
    | 'route';

interface NavigationRouteIconProps {
    route: NavigationRouteIconType;
    size?: number | string;
    style?: CSSProperties;
}

const workspaceResourceTypeMap: Partial<Record<NavigationRouteIconType, string>> = {
    dashboards: 'dashboard',
    folders: 'folders',
    investments: 'investment',
    lifecycles: 'lifecycle',
    lists: 'list',
    memos: 'memo',
    pipelines: 'pipeline',
    tasks: 'task',
    teams: 'team',
};

const NavigationRouteIcon: FC<NavigationRouteIconProps> = ({ route, size = '1rem', style }) => {
    const resource = workspaceResourceTypeMap[route];

    if (resource) {
        return <WorkspaceResourceGlyph resource={resource} size={size} style={style} />;
    }

    switch (route) {
        case 'home':
            return <RiHomeLine size={size} style={style} />;
        case 'inbox':
            return <Inbox size={size} style={style} />;
        case 'search':
            return <TbSearch size={size} style={style} />;
        case 'drafts':
            return <FilePen size={size} style={style} />;
        case 'archive':
            return <TbArchive size={size} style={style} />;
        case 'profile':
            return <TbUserCircle size={size} style={style} />;
        case 'settings':
            return <TbSettings size={size} style={style} />;
        case 'relations':
            return <TbCirclesRelation size={size} style={style} />;
        case 'trash':
            return <TbTrash size={size} style={style} />;
        case 'route':
        default:
            return <TbRoute size={size} style={style} />;
    }
};

export default NavigationRouteIcon;
